import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react'

// Слот контекстного действия раздела в верхнем хедере. Страница регистрирует
// свою кнопку (например «создать токен») через useHeaderAction — TopBar её
// рендерит. Сам диалог и его состояние остаются в странице; в хедер уезжает
// только триггер.

interface HeaderActionApi {
  action: ReactNode
  setAction: (node: ReactNode) => void
}

const HeaderActionCtx = createContext<HeaderActionApi | null>(null)

export function HeaderActionProvider({ children }: { children: ReactNode }) {
  const [action, setAction] = useState<ReactNode>(null)
  const value = useMemo(() => ({ action, setAction }), [action])
  return <HeaderActionCtx.Provider value={value}>{children}</HeaderActionCtx.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useHeaderActionValue(): ReactNode {
  return useContext(HeaderActionCtx)?.action ?? null
}

// eslint-disable-next-line react-refresh/only-export-components
export function useHeaderAction(node: ReactNode): void {
  const setAction = useContext(HeaderActionCtx)?.setAction
  useEffect(() => {
    if (!setAction) return
    setAction(node)
    return () => setAction(null)
  }, [node, setAction])
}
